import styled from "styled-components";
import Backdrop from "../Backdrop";
import ModalWrapper from "../ModalWrapper";
import Spacer from "../Spacer";
import Button from "../Button";
import { useHistory } from "react-router-dom";

const Wrapper = styled(Backdrop)`
  .modal {
    background-color: #fff;
    width: 560px;
    padding: 24px;
    border-radius: 16px;
  }

  img {
    width: 100%;
    height: auto;
  }

  .content {
    text-align: center;
    font-size: 16px;
    font-weight: 450;

    header {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 6px;
    }

    .text {
      color: var(--body_text);
    }
  }
  .btn-flex {
    gap: 12px;

    button {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 768px) {
    .modal {
      width: calc(100% - 24px);
    }

    .content {
      font-size: 14px;

      header {
        font-size: 16px;
      }
    }

    .btn-flex {
      flex-direction: column-reverse;
    }
  }
`;

const EngagementModal = ({
  title,
  content,
  modalImage,
  actionText,
  routeTo,
  handleCancel,
}) => {
  const history = useHistory();
  return (
    <Wrapper className={`flexRow justifyEnd show`}>
      <ModalWrapper>
        <div className="modal">
          <img src={modalImage} alt="illustration" />
          <Spacer y={2.4} />
          <div className="content">
            <header>{title}</header>
            <p className="text">{content}</p>
          </div>
          <Spacer y={4.0} />
          <div className="flexRow alignCenter justifySpaceBetween btn-flex">
            <Button
              className="borderedGrey"
              text="Cancel"
              fullWidth
              onClick={handleCancel}
            />
            <Button
              onClick={() => history.push(routeTo)}
              text={actionText}
              bg="var(--secondary)"
              fullWidth
            />
          </div>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};

export default EngagementModal;
